var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAllActivitiesUnActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2D81F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75:2508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7095 8.41107C21.4663 8.29901 21.1797 8.34261 20.9807 8.52188L19.931 9.45131C19.9025 9.47673 19.8594 9.47657 19.831 9.45101L18.4028 8.17359C18.1444 7.94214 17.7534 7.94214 17.4951 8.17359L16.0681 9.44984C16.0394 9.47548 15.996 9.47548 15.9673 9.44984L14.5402 8.17359C14.2819 7.94217 13.8908 7.94217 13.6325 8.17359L12.2041 9.45101C12.1755 9.47657 12.1323 9.47669 12.1036 9.45127L11.0529 8.52188C10.7742 8.27401 10.3473 8.29901 10.0994 8.57774C9.98826 8.70274 9.92745 8.86453 9.92873 9.03177V22.9683C9.92623 23.3419 10.2271 23.6467 10.6006 23.6492C10.768 23.6504 10.9298 23.5894 11.0548 23.4782L12.1045 22.5487C12.1331 22.5233 12.1762 22.5235 12.2046 22.549L13.6328 23.8264C13.8911 24.0579 14.2822 24.0579 14.5405 23.8264L15.9676 22.5502C15.9963 22.5246 16.0397 22.5246 16.0684 22.5502L17.4955 23.8264C17.7538 24.0578 18.1449 24.0578 18.4032 23.8264L19.8317 22.549C19.8603 22.5234 19.9035 22.5233 19.9322 22.5487L20.9828 23.4781C21.2617 23.7259 21.6886 23.7007 21.9363 23.4218C22.0473 23.297 22.108 23.1354 22.1068 22.9683V9.03177C22.1104 8.76404 21.9541 8.51991 21.7095 8.41107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5617 15.4119H18.4217C18.94 15.4119 19.1886 14.7722 18.8061 14.4222L17.6544 13.3685C17.4224 13.1563 17.0621 13.1723 16.8498 13.4043C16.6375 13.6364 16.6535 13.9967 16.8855 14.2089L16.9554 14.2728H13.5617C13.2472 14.2728 12.9922 14.5278 12.9922 14.8424C12.9922 15.1569 13.2472 15.4119 13.5617 15.4119Z",
    fill: "#2D81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4221 16.6221H13.5622C13.0438 16.6221 12.7952 17.2618 13.1777 17.6118L14.3294 18.6654C14.5614 18.8777 14.9217 18.8617 15.134 18.6296C15.3464 18.3976 15.3303 18.0373 15.0983 17.825L15.0284 17.7611H18.4221C18.7366 17.7611 18.9916 17.5061 18.9916 17.1916C18.9916 16.8771 18.7366 16.6221 18.4221 16.6221Z",
    fill: "#2D81F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75:2508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAllActivitiesUnActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/all-activities-un-active.f99f07f7.svg";
export { ForwardRef as ReactComponent };